import { handleFetchResponse } from "@lib/handle-fetch-response"
import fetch from "isomorphic-unfetch"
import * as qs from "query-string"

const PROJECT_ID = "d1cf10f7-8b9a-0118-4bbc-02df26d66a7b"
const PREVIEW_API_KEY =
  "ew0KICAiYWxnIjogIkhTMjU2IiwNCiAgInR5cCI6ICJKV1QiDQp9.ew0KICAianRpIjogIjk0MDQwOWQ4NWMyYjQ4OGY4ZjNiNTk2MTJjOWRlODI1IiwNCiAgImlhdCI6ICIxNTgyNTM0OTkzIiwNCiAgImV4cCI6ICIxOTI4MTM0OTkzIiwNCiAgInByb2plY3RfaWQiOiAiZDFjZjEwZjc4YjlhMDExODRiYmMwMmRmMjZkNjZhN2IiLA0KICAidmVyIjogIjEuMC4wIiwNCiAgImF1ZCI6ICJwcmV2aWV3LmRlbGl2ZXIua2VudGljb2Nsb3VkLmNvbSINCn0.lDvjWNEUOknktY_HOgQB-21mYPQnEJTdT_tK23jLTYk"

const getKontentApiUrl = (preview?: boolean): string =>
  `https://${preview ? "preview-" : ""}deliver.kontent.ai/${PROJECT_ID}/`

type System = {
  id: string
  name: string
  codename: string
  language: string
  type: string
  sitemap_locations: any[]
  last_modified: Date
}

export type Item<Elements = any> = { system: System; elements: Elements }

export type SingleItemResponse<Elements = any> = {
  item: Item<Elements>
  modular_content: { [key: string]: any }
}

export type MultipleItemResponse<Elements = any> = {
  items: Item<Elements>[]
  modular_content: { [key: string]: any }
  pagination: {
    skip: number
    limit: number
    count: number
    total_count?: number
  }
}

type Params = {
  [key: string]: string | number | string[]
}

type Args = {
  path: string
  preview?: boolean
  params: Params
  route?: string
}

export const fetchContent = ({
  path,
  preview,
  params,
  route = "items",
}: Args) => {
  let url = `${getKontentApiUrl(preview)}${route}${path}`
  if (params) {
    url += `?depth=2&${qs.stringify(params, { arrayFormat: "comma" })}`
  }
  const usePreview = preview || process.env.NODE_ENV === "development"
  return fetch(url, {
    headers: usePreview
      ? {
          Authorization: `Bearer ${PREVIEW_API_KEY}`,
        }
      : undefined,
  }).then(handleFetchResponse)
}
